import nationalEnv from './national'
import internationalEnv from './international'

import isInternational from '@/utils/isInternational'


const env = isInternational() ? internationalEnv : nationalEnv

export default env
